import React from "react";

import jiraIntegrationVideo from "~/legacy-assets/videos/jiraIntegration.mp4";

import styles from "../css/Jira.module.css";

export const aboutJiraIntegrationContent = (
	<>
		<div className={styles.header}>
			<span className={styles.headerTitle}>About this integration</span>
		</div>
		<div>
			<p>
				Create, import, and manage Jira issues from Fellow. With this integration, you can use Fellow for planning
				high-level action items from within your 1-on-1s and team meetings, while doing more granular project management
				using your existing workflows in Jira.
			</p>
			<ul>
				<li>Create Jira issues directly from action items in Fellow.</li>
				<li>Pull in existing Jira issues as linked action items from any note series.</li>
				<li>
					Use 2-way sync to keep issue titles, assignees, and due dates automatically in sync between Fellow and Jira
					(requires project-specific configuration).
				</li>
				<li>
					Automatically transition Jira issues when a linked action item is completed (requires project-specific
					configuration).
				</li>
			</ul>
		</div>
	</>
);

export const aboutInstalled = (
	<>
		{aboutJiraIntegrationContent}
		<div className={styles.aboutTextH5}>Configuring integration settings</div>
		<div className={styles.aboutTextH6}>Adding your Jira project to Fellow</div>
		From the settings tab, you can set configuration options for how Fellow will interact with different projects within
		Jira. Once you add a project, you{"'"}ll be able to toggle additional settings that allow you to control what
		information flows between action items in Fellow and linked Jira issues.
		<div className={styles.aboutTextH6}>2-way sync</div>
		This per-project setting defines whether Fellow will keep the title, due date, and assignee of any linked Jira
		issues in sync with Fellow. If this option is enabled, any changes to the action item text, due date, or assignee
		inside Fellow will automatically propagate to the linked Jira issue. Similarly, any changes to a linked Jira issue
		will automatically sync back to Fellow. When this option is disabled, changes will not propagate beyond the point at
		which the issue was linked. Please note that Fellow will sync assignees based on email address. If the Fellow
		assignee does not exist as a Jira user, the assignee will not sync. Similarly, if the assignee within Jira changes
		to someone who does not have access to the note series on Fellow, the assignee will not sync.
		<div className={styles.aboutTextH6}>Push status {"&"} status mapping</div>
		From Jira settings, you can enable Push status for your workspace. When enabled, checking off your action item in
		Fellow will also change the status of that item in Jira. You can map Fellow{"'"}s action item statuses to your Jira
		project to control what the status will change to in Jira. When Push status is off, checking an item off in Fellow
		won{"'"}t have any effect on the Jira issue, and you won{"'"}t be able to map your status.
	</>
);

export const aboutNotInstalled = (
	<>
		{aboutJiraIntegrationContent}

		<div className={styles.videoContainer}>
			<video autoPlay loop muted src={jiraIntegrationVideo} preload="auto" width="100%" crossOrigin="anonymous" />
		</div>
	</>
);
